import React, { useState } from 'react'
import style from './MakeHeader.module.css'
import renderImage from '../../../source/importImg'

/**
 * JumpToMenu
 * -------------------------------------------------
 * The burger "Jump to" menu (Mechanical / Electronic / Coding / Simulate).
 * Owns its own open/close state and renders the full-screen
 * click-outside overlay so it is fully self-contained.
 */
export default function JumpToMenu({ data, onJumpClick }) {
    const [isJumpMenuOpen, setJumpMenuOpen] = useState(false)

    if (!data) return null

    return (
        <>
            {isJumpMenuOpen && (
                <div
                    className={style.clickOutsideOverlay}
                    onClick={() => setJumpMenuOpen(false)}
                />
            )}

            <div className={style.header_button}>
                <div className={style.burger_button}>
                    <img
                        className={style.iconBtnSize}
                        src={renderImage('skip')}
                        onClick={() => setJumpMenuOpen(!isJumpMenuOpen)}
                        alt="Menu"
                    />
                    <span className={style.tooltiptext}>
                        <p>Menu</p>
                    </span>
                </div>

                {/* THE POPUP MENU */}
                {isJumpMenuOpen && (
                    <div className={style.jumpMenuPopup}>
                        {/* Header: Arrow + "Jump to" */}
                        <div className={style.jumpMenuHeader}>
                            <img
                                src={renderImage('skipIcon')}
                                className={style.jumpMenuArrow}
                                alt=""
                            />
                            <span>Jump to</span>
                        </div>

                        {/* List Items */}
                        <div className={style.jumpMenuList}>
                            {data.options.map((optionName, index) => {
                                const isSelected = index === data.selected
                                return (
                                    <div
                                        key={index}
                                        className={`${style.jumpMenuItem} ${isSelected ? style.jumpMenuItemSelected : ''}`}
                                        onClick={() => {
                                            if (onJumpClick)
                                                onJumpClick(index, optionName)
                                            setJumpMenuOpen(false)
                                        }}
                                    >
                                        {optionName}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
